'use client';

import { getVersion } from '@/lib/build-info';

/**
 * Version badge component for displaying the current app version
 * Useful for admin panels, footer, or debugging UI
 */
export function VersionBadge() {
  const version = getVersion();

  return (
    <div className="inline-flex items-center rounded-md bg-muted px-2 py-1 text-xs font-mono text-muted-foreground">
      <span className="mr-1">v</span>
      {version}
    </div>
  );
}
